const usTimezones = [
    "America/New_York",      // 东部时区
    "America/Chicago",       // 中部时区
    "America/Denver",        // 山地时区
    "America/Phoenix",      // 山地时区（亚利桑那州，不实行夏令时）
    "America/Los_Angeles",  // 太平洋时区
    "America/Anchorage",    // 阿拉斯加时区
    "America/Adak",         // 阿拉斯加时区（阿留申群岛）
    "Pacific/Honolulu"      // 夏威夷时区
];

function isUSTimezone() {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return usTimezones.includes(userTimezone);
}

function getVariantId() {
    // const urlParams = document.querySelectorAll('[name="id"]');

    // console.log(urlParams)
  
    // var values = urlParams.urlParams[urlParams.length - 2].getAttribute('value')
    // console.log('Variant id:', values);
  
    // if (urlParams) {
    //     sendHTTPRequest(values);
    // }

    const xpath = "//safe-sticky//div[@data-block-type='buy-buttons']//form//input[3]";

    const result = document.evaluate(
      xpath,                // XPath 表达式
      document,             // 上下文节点（从整个文档开始搜索）
      null,                 // 命名空间解析器（通常为 null）
      XPathResult.FIRST_ORDERED_NODE_TYPE, // 返回类型（返回第一个匹配的节点）
      null                  // 结果复用（通常为 null）
    );
    const inputElement = result.singleNodeValue;
    console.log(inputElement)
    if (inputElement) {
      // 获取 value 属性
      const value = inputElement.defaultValue;
      console.log("Value:", value);  
      
      sendHTTPRequest(value);
    } else {
      console.log("Element not found");
    }
}

function createShippingElement(data) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("Shipping-time");
    newDiv.style.margin = '10px 0px 20px 5px';
    // newDiv.style.paddingLeft = '35px';
    const newSpan = document.createElement("span");
    if (data >= 1) {
        const now = new Date();
        // const now = new Date(new Date('2026-11-15T17:10:00'));
        const cutoffTime = new Date(now).setHours(8, 30, 0, 0);
        const endOfDay = new Date(now).setHours(23, 59, 59, 999);
        let hours, minutes;
        let shipDate = new Date(now); 
        let shipText = '';
        if (now < cutoffTime) {
            const diffToday = cutoffTime - now;
            const totalMinutesToday = Math.floor(diffToday / (1000 * 60));
            hours = Math.floor(totalMinutesToday / 60);
            minutes = totalMinutesToday % 60;
        } else {
            const diffTom = endOfDay - now;
            const totalMinutesTom = Math.floor(diffTom / (1000 * 60));
            hours = Math.floor(totalMinutesTom / 60);
            minutes = totalMinutesTom % 60;
            shipDate.setDate(shipDate.getDate() + 1); // 第二天发货
        }
        const timeSpan = document.createElement('span');
        timeSpan.textContent = `${hours} hrs ${minutes} mins`;
        timeSpan.style.color = '#375542'; 
        timeSpan.style.fontWeight = "800";
        
        newSpan.innerHTML = ''; 
        newSpan.appendChild(document.createTextNode('Order within '));
        newSpan.appendChild(timeSpan);
        
        // 定义节假日数组 (格式: MM-DD)
        const holidays = [
            '12-25', // 圣诞节
            '01-01', // 元旦
            '11-26' // 感恩节
        ];
        
        // 检查日期是否为节假日或周末
        function isHolidayOrWeekend(date) {
            const monthDay = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            const dayOfWeek = date.getDay();
            return holidays.includes(monthDay) || dayOfWeek === 0 || dayOfWeek === 6; 
        }
        
        // 计算日期
        function calculateDeliveryDate(startDate, businessDays) {
            const deliveryDate = new Date(startDate);
            while (isHolidayOrWeekend(deliveryDate)) {
                deliveryDate.setDate(deliveryDate.getDate() + 1);
            }
            deliveryDate.setDate(deliveryDate.getDate() + businessDays)
            return deliveryDate;
        }
        
        // 格式化日期为 "Month Day" 格式
        function formatDateToMonthDay(date) {
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 
                                'July', 'August', 'September', 'October', 'November', 'December'];
            const month = monthNames[date.getMonth()];
            const day = date.getDate();
            return `${month} ${day}`;
        }
        
        // // 查看更多物流
        // const seeMoreLink = document.createElement('span');
        // seeMoreLink.style.fontSize = '12px';
        // seeMoreLink.style.marginLeft = '10px';
        // seeMoreLink.style.f
        // seeMoreLink.style.color = 'blue';
        // seeMoreLink.style.cursor = 'pointer';
        // seeMoreLink.textContent = 'See more delivery options ▼';
        // // 收起
        // const collapseLink = document.createElement('span');
        // collapseLink.style.fontSize = '12px';
        // collapseLink.style.marginLeft = '50px';
        // collapseLink.style.color = 'blue';
        // collapseLink.style.cursor = 'pointer';
        // collapseLink.textContent = 'Collapse ▲';
        // collapseLink.style.display = 'none';

        // seeMoreLink.addEventListener('click', function() {
        //     expeditedDiv.style.display = 'block';
        //     seeMoreLink.style.display = 'none';
        //     collapseLink.style.display = 'inline';
        // });
        // collapseLink.addEventListener('click', function() {
        //     expeditedDiv.style.display = 'none';
        //     seeMoreLink.style.display = 'inline';
        //     collapseLink.style.display = 'none';
        // });

        // 创建 Free 信息
        const expeditedDiv = document.createElement('div');
        expeditedDiv.style.marginTop = '3px';
        
        const expeditedStrong = document.createElement('strong');
        const expeditedStartDate = new Date(shipDate);
        const expeditedDeliveryDate = calculateDeliveryDate(expeditedStartDate, 5);
        expeditedStrong.textContent = formatDateToMonthDay(expeditedDeliveryDate);
        
        expeditedDiv.appendChild(document.createTextNode('Free Standard will be delivered on '));
        expeditedDiv.appendChild(expeditedStrong);
        // expeditedDiv.appendChild(collapseLink);
        // expeditedDiv.style.display = 'none';
        // 创建 Express 信息
        const expressDiv = document.createElement('div');
        expressDiv.style.marginTop = '3px';
        
        const expressStrong = document.createElement('strong');
        const expressStartDate = new Date(shipDate);
        const expressDeliveryDate = calculateDeliveryDate(expressStartDate, 2);
        expressStrong.textContent = formatDateToMonthDay(expressDeliveryDate);
        
        expressDiv.appendChild(document.createTextNode('Expedited will be delivered on '));
        expressDiv.appendChild(expressStrong);
        // expressDiv.appendChild(seeMoreLink);

        const mediaQuery = window.matchMedia('(min-width: 750px)');
        if (!mediaQuery.matches) {
            expeditedDiv.style.display = 'block';
            // seeMoreLink.style.display = 'none';
            // collapseLink.style.display = 'none';
        }
        
        newDiv.appendChild(newSpan);
        newDiv.appendChild(expressDiv);
        newDiv.appendChild(expeditedDiv);
    } 
    return newDiv;
}

async function sendHTTPRequest(variantId) {
    // 发送请求到后端，将 variantId 作为参数传递
    const response = await fetch(`https://api.ugeat.com?variantId=${variantId}`); //需要添加服务器地址
    const data = await response.json();
    console.log('request-data:', data);
    const existingInventoryQuantity = document.querySelector('.Inventory-quantity');
    if (existingInventoryQuantity) {
        // 若存在，则移除该元素
        existingInventoryQuantity.remove();
    }
    const targetElement = document.querySelector('[data-block-type="quantity-selector"]')
    // const nextSibling = targetElement.previousElementSibling;
    if (targetElement) {

        // 使用 window.matchMedia 检测屏幕宽度是否大于 750px
        const mediaQuery = window.matchMedia('(min-width: 750px)');
        // 定义一个函数来处理样式设置
        function setStyles() {
            if (mediaQuery.matches) {
                // 当屏幕宽度大于 750px 时设置样式
                targetElement.style.display = 'flex';
                targetElement.style.justifyContent = 'flex-start';
                targetElement.style.alignItems = "center";
            } else {
                // 当屏幕宽度小于等于 750px 时移除样式（可选）
                targetElement.style.display = '';
                targetElement.style.justifyContent = '';
                targetElement.style.alignItems = '';
            }
        }
        // 初始调用函数以设置初始样式
        setStyles();
        // 监听媒体查询的变化，当屏幕宽度改变时重新设置样式
        mediaQuery.addEventListener('change', setStyles);
        const newDiv = document.createElement("div");
        newDiv.style.margin = '10px 0px';
        newDiv.classList.add("Inventory-quantity");
        const newSpan = document.createElement("span");
        const newI = document.createElement("i")
        if (data > 10) {
            newSpan.textContent = "Available in U.S. warehouse";
            newI.classList.add("safe");
        } else if (data >= 1) {
            // 创建一个新的 span 元素来包裹 data
            const dataSpan = document.createElement('span');
            dataSpan.textContent = data;
            dataSpan.style.color = '#e32c2b';
            dataSpan.style.fontWeight = "bold"

            // 拼接文本内容
            newSpan.appendChild(document.createTextNode('Only '));
            newSpan.appendChild(dataSpan);
            newSpan.appendChild(document.createTextNode('  left in U.S. warehouse'));
            newI.classList.add("danger");
        }
        newDiv.appendChild(newI);
        newDiv.appendChild(newSpan);
        // targetElement.appendChild(newDiv);
        const existingShipping = document.querySelector('.Shipping-time');
        if (existingShipping) {
            existingShipping.remove();
        }
        if (window.shippingRefreshInterval) {
            clearInterval(window.shippingRefreshInterval);
        }
        if(data > 0) {
            let targetElements = document.querySelector('[data-block-type="quantity-selector"]');
            const shippingDiv = createShippingElement(data);
            if (targetElements) {
                targetElements.insertAdjacentElement('afterend', shippingDiv);
            }else {
                const observer1 = new MutationObserver((mutationsList) => {
                    for (const mutation of mutationsList) {
                        if (mutation.type === 'childList') {
                            const swatches = getDiv();
                            if (swatches) {
                                observer1.disconnect();
                                swatches.insertAdjacentElement('afterend', shippingDiv);
                                break;
                            }
                        }
                    }
                });
                observer1.observe(document.body, { childList: true, subtree: true });
            }
            targetElements.insertAdjacentElement('afterend', newDiv);
            window.shippingRefreshInterval = setInterval(async () => {
                const existingShipping = document.querySelector('.Shipping-time');
                if (existingShipping) {
                    try {
                        const newShippingElement = createShippingElement(data);
                        existingShipping.replaceWith(newShippingElement);
                    } catch (error) {
                        console.error('Refresh error:', error);
                    }
                }
            },60000);
        }
    }
}

// 定义一个函数用于处理 variant 参数的变化
async function handleVariantChange() {
    if (!isUSTimezone()) {
        console.log('The user is not in the US and does not perform follow-up actions');
        return;
    }

    let variantValue = await getVariantId();
}
console.log("product is load")
// 页面加载完成后，先获取一次 variant 参数
handleVariantChange();
const xpath1 = "//safe-sticky//div[@data-block-type='variant-picker']";
const result1 = document.evaluate(
  xpath1,                // XPath 表达式
  document,             // 上下文节点（从整个文档开始搜索）
  null,                 // 命名空间解析器（通常为 null）
  XPathResult.FIRST_ORDERED_NODE_TYPE, // 返回类型（返回第一个匹配的节点）
  null                  // 结果复用（通常为 null）
);
const inputElement1 = result1.singleNodeValue;
console.log(inputElement1)
inputElement1.addEventListener("click",function(){
  setTimeout(()=>{
    handleVariantChange();
  }, 100)
})
